const TAX_ID_EXEMPT_RESIDENCIES = new Set(['DE', 'DEU']);
export const MAX_TAX_ID_LENGTH = 255;
export function requiresTaxId(taxResidency) {
    const residency = (taxResidency ?? '').trim().toUpperCase();
    return !TAX_ID_EXEMPT_RESIDENCIES.has(residency);
}
export function normalizeTaxId(taxId) {
    if (typeof taxId !== 'string')
        return '';
    return taxId.replace(/\s+/g, '').toUpperCase();
}
export function isValidTaxId(taxId) {
    const normalized = normalizeTaxId(taxId);
    return normalized.length > 0 && normalized.length <= MAX_TAX_ID_LENGTH;
}
//# sourceMappingURL=tradevest-tax.utils.js.map